import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export interface ProductDto {
  id: number;
  name: string;
  sku: string;
  description?: string | null;
  defaultPrice?: number | null;
  isTaxable: boolean;
  defaultItem: boolean;
}

export interface ProductCreateDto {
  name: string;
  sku: string;
  description?: string | null;
  defaultPrice?: number | null;
  isTaxable: boolean;
  defaultItem: boolean;
}

export interface ProductUpdateDto {
  name: string;
  sku: string;
  description?: string | null;
  defaultPrice?: number | null;
  isTaxable: boolean;
  defaultItem: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/products';

  getAll(): Observable<ProductDto[]> {
    return this.http.get<ProductDto[]>(this.apiUrl);
  }

  getById(id: number): Observable<ProductDto> {
    return this.http.get<ProductDto>(`${this.apiUrl}/${id}`);
  }

  create(data: ProductCreateDto): Observable<ProductDto> {
    return this.http.post<ProductDto>(this.apiUrl, data);
  }

  update(id: number, data: ProductUpdateDto): Observable<ProductDto> {
    return this.http.put<ProductDto>(`${this.apiUrl}/${id}`, data);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
